export default "__VITE_ASSET__BlSaD4ZJ__"